import { GasPrices } from '@badger-dao/sdk';
import { action, extendObservable } from 'mobx';
import { RootStore } from '../RootStore';

export class NetworkStore {
	private store: RootStore;
	public gasPrices: GasPrices | null;
	public currentBlock: number;

	constructor(store: RootStore) {
		this.store = store;
		this.gasPrices = null;
		this.currentBlock = 1;

		extendObservable(this, {
			currentBlock: this.currentBlock,
			gasPrices: this.gasPrices
		});
	}

	updateGasPrices = action(async () => {
		this.gasPrices = await this.store.api.loadGasPrices();
	});
}
